import { Button } from "antd";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { useState } from "react";
import { GuestLink } from "../../types/GuestLink";
import { Link } from "react-router-dom";

type GuestListLinksProps = {
  header: string;
  links: GuestLink[];
  isComplex?: boolean;
  additionalClass?: string;
};

export const ListLinks = ({
  header,
  links,
  isComplex,
  additionalClass,
}: GuestListLinksProps) => {
  const [isListCollapsed, seIsListCollapsed] = useState<boolean>(true);

  return (
    <div className={additionalClass || ""}>
      <Button
        type="link"
        style={{ height: "25px" }}
        className="useful-link px-0 py-0"
        onClick={() => seIsListCollapsed(!isListCollapsed)}
      >
        {header}
        {isListCollapsed ? <DownOutlined /> : <UpOutlined />}
      </Button>
      {!isListCollapsed && (
        <div className="useful-links-list items">
          {links.map((item: GuestLink, i: number) => {
            return (
              <div key={i} className="mb-3">
                {!isComplex ? (
                  <Link
                    type="link"
                    className="useful-link item ant-btn-link"
                    to={item.to || "#"}
                  >
                    {item.title}
                  </Link>
                ) : (
                  <div key={i}>{item.node}</div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
